<template>
	<v-container class="no-MW">
	<!--리스트 버튼-->
    <!--<v-row no-gutters class="align-center doc_list_btn">
      <v-checkbox class="coNlist_chk"></v-checkbox>
      <v-btn class="btn18_00" outlined><span class="icon copy"></span>복사</v-btn>
      <v-btn class="btn18_00" outlined><span class="icon cancel"></span>취소</v-btn>
      <v-btn class="btn18_00" outlined><span class="icon delete"></span>삭제</v-btn>
      <v-btn class="btn18_00" outlined><span class="icon print"></span>인쇄</v-btn>
      <v-btn class="btn18_00" outlined><span class="icon download"></span>저장</v-btn>
    </v-row>-->
    <!--/리스트 버튼-->
    <!--리스트-->
    <v-row no-gutters class="doc_list">
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"

      >
      <!--반복: 리스트 카드-->
      <v-card v-bind:class="[ list_card, { con_C02: getSelfContract(contract.senderAddress, contract.receiverAddress, contract.senderBrokerAddress, contract.receiverBrokerAddress) }]" v-for="(contract, index) of contractList" :key="index" @click="contractListClick(contract.senderAddress, contract.contractSeq, contract.contractStatus, contract.lockType, contract.contractNumber, contract.tmp, contract.contractFileName, contract.brokerReceiverName, contract.receiverName, contract.receiverBrokerAddress, contract.receiverAddress )">
        <!-- 결재상태가 결재요청이면서 본인이 보낸 결재건이면 체크박스 숨김처리 -->
        <!--<v-checkbox class="coNlist_chk"></v-checkbox>-->
        <span class="transcipient re" v-if="getTrans (contract.senderAddress, contract.receiverAddress, contract.contractStatus)"></span>
        <span class="transcipient" v-else-if="getTrans ( contract.receiverAddress, contract.senderAddress, contract.contractStatus)"></span>

          <v-list-item class="carD_box_clB">
            <div class="carD_01">
              <div class="carD_chip00" v-if="contract.contractStatus == 'PR'">
                <v-chip class="st01">검토 요청</v-chip>
                <!--계약 상태 ***상태별 텍스트 변경***  /*취소 / st01:검토 요청 / st02:내 서명 대기 / st03:서명 진행 / st04:서명 거부 / st05:완료 / st06:임시저장 **/-->
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'CR' &&  getAddress (contract.receiverAddress)">
                <v-chip class="st02">내 서명 대기</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'CR' &&  getAddress (contract.senderAddress)">
                <v-chip class="st03">서명 진행</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'DR' &&  getAddress (contract.receiverAddress)">
                <v-chip class="st04">내 서명 대기(폐기)</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'DR' &&  getAddress (contract.senderAddress)">
                <v-chip class="st04">서명 진행(폐기)</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'CN'">
                <v-chip class="st04">서명 거부</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'PN'">
                <v-chip class="st04">검토 거부</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'PC'">
                <v-chip class="st05">승인대기</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'CC'">
                <v-chip class="st05">완료</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'DC'">
                <v-chip class="st04">폐기완료</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contract.contractStatus == 'CA'">
                <v-chip>요청취소</v-chip>
              </div>
              <div class="carD_01_txt">
                <!--비회원--><span class="st_guest" v-if="contract.tmp">비회원</span>
                <!--계약명--><span class="st_tt_01">{{ contract.contractFileName }}</span>
              </div>
              <div class="dateBox">
                <span class="st_txt">[최종 수정]</span>
                <span class="st_txt">{{ contract.saveDate }}</span>
              </div>
            </div>
          </v-list-item>

          <v-list-item class="carD_02">

            <ul class="pattern_ulTxtBox" v-if="contract.contractStatus == 'CN' || contract.contractStatus == 'CC' || contract.contractStatus == 'DC'">
              <li>
                <span class="txt_icon">요청</span>
                <span class="txt_txt02 no_pr">{{ contract.receiverName }}</span>
              </li>
              <li v-if="contract.brokerReceiverName != '' && contract.brokerReceiverName != null">
                <span class="txt_icon icon_C02">요청 대행자</span>
                <span class="txt_txt02 no_pr">{{ contract.brokerReceiverName }}</span>
              </li>
              <li>
                <span class="txt_icon">수신</span>
                <span class="txt_txt02 no_pr">{{ contract.senderName }}</span>
              </li>
              <li v-if="contract.brokerSenderName != '' && contract.brokerSenderName != null">
                <span class="txt_icon icon_C02">수신 대행자</span>
                <span class="txt_txt02 no_pr">{{ contract.brokerSenderName }}</span>
              </li>
            </ul>

            <ul class="pattern_ulTxtBox" v-else>
              <li>
                <span class="txt_icon">요청</span>
                <span class="txt_txt02 no_pr">{{ contract.senderName }}</span>
              </li>
              <li v-if="contract.brokerSenderName != '' && contract.brokerSenderName != null">
                <span class="txt_icon icon_C02">요청 대행자</span>
                <span class="txt_txt02 no_pr">{{ contract.brokerSenderName }}</span>
              </li>
              <li>
                <span class="txt_icon">수신</span>
                <span class="txt_txt02 no_pr">{{ contract.receiverName }}</span>
              </li>
              <li v-if="contract.brokerReceiverName != '' && contract.brokerReceiverName != null">
                <span class="txt_icon icon_C02">수신 대행자</span>
                <span class="txt_txt02 no_pr">{{ contract.brokerReceiverName }}</span>
              </li>
            </ul>
          </v-list-item>

      </v-card>
        <!--리스트 카드-->
        <v-row no-gutters v-if="contractList <= 0">
          <v-col cols="12" class="no_serch pt-10 pb-10">
            <span class="icon_no_serch"></span>
            검색 결과가 없습니다.
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!--/리스트-->
    <!--/페이지-->
    <v-row no-gutters class="justify-center row_mt-20">
      <v-pagination
        v-model="page"
        :length="total"
        @input="handlePageChange"
        total-visible="7"
        circle
      ></v-pagination>
    </v-row>
    <!--/페이지-->
    <pubCert ref="pubCert" :certRegno="purCertInfo.certRegNo" :hash="purCertInfo.hash" @childs-event="purCertResult"></pubCert>
    <perCert ref="perCert" :perName="perCerInfo.perName" :perNumber="perCerInfo.perNumber"  @per-event="perCertResult"></perCert>
    <passCheck ref="passCheck" :ctrNumber="ctrInfo.contractNumber" @pass-event="passCheckResult"></passCheck>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
		</v-container>
</template>
<script>
import { getContractList/* , getContractLock */ } from '@/api/contract/contractList'
import PubCert from "@/components/pubCert"
import PerCert from "@/components/perCert"
import passCheck from "@/components/passCheck"
import { ctrLockReadSuc, ctrLockReadFail, ctrLockReadPerSuc } from '@/api/contractLock'

export default {
  name: 'contractList',
  props: {
    searchParams: Object
  },
  components: {
    PubCert,
    PerCert,
    passCheck
  },
  data () {
    return {
      purCertInfo:{
        certRegNo:'',
        hash: ''
      },
      pageParam: {
        page: 0,
        size: 10
      },
      page: 1,
      total: 0,
      contractList: null,
      perCerInfo:{
        perName:'',
        perNumber:''
      },
      ctrInfo:{
        contractNumber: '',
        contractSeq: '',
        ctrLockType:'',
        failCnt:'',
        signType: '',
        acqDate: '',
        resultCode: '',
        contractFileName: '',
        contractStatus: ''
      },
      receiverName: '',
      receiverAddress: '',
      list_card: 'list_carD_con',
    }
  },
  created () {

  },
  mounted () {
    // this.getContractList()
  },
  methods: {
    getAddress (address) {
      var orgname = this.$store.state.user.orgname
      var orgaddr = this.$store.state.user.orgaddr
      var useraddr = this.$store.state.user.useraddr
      if (orgname) {
        if(orgaddr === address) {
          return true
        }else{
          return false
        }
      } else {
        if(useraddr === address) {
          return true
        }else{
          return false
        }
      }
    },
    getTrans (address, baddress, stats) {
      var orgname = this.$store.state.user.orgname
      var orgaddr = this.$store.state.user.orgaddr
      var useraddr = this.$store.state.user.useraddr
      if (stats === 'CC' || stats === 'CN') {
        if (orgname) {
          if(orgaddr === baddress) {
            return true
          }else{
            return false
          }
        } else {
          if(useraddr === baddress) {
            return true
          }else{
            return false
          }
        }
      }else {
        if (orgname) {
          if(orgaddr === address) {
            return true
          }else{
            return false
          }
        } else {
          if(useraddr === address) {
            return true
          }else{
            return false
          }
        }
      }

    },
    contractListClick (senderAddress, seq, ctrStat, lockType, contractNumber, tmp, contractFileName, brokerName, receiveName, brokerAddress, receiveAddress) {
      if(this.$store.state.user.orgtmp) {
        this.$refs.confirm.open('alert', '미리보기', '기업 인증 후 미리보기가 가능합니다.')
      }else if(tmp) {
        this.$refs.confirm.open('alert', '비회원 계약', '해당 계약은 비회원 계약입니다. 회원전환이 된 이후에 계약 열람 가능합니다.')
      }else {
        this.ctrInfo.contractStatus = ctrStat
        if(lockType === null) {
          lockType = 0
        }
        if(this.getAddress(senderAddress)) {
          this.ctrInfo.contractSeq = seq
          this.ctrInfo.contractNumber = contractNumber
          this.goDetail()
        }else{
          if(ctrStat === 'CR' && lockType !== 0) {
            if(brokerName !== '' && brokerName !== null) {
              this.receiverName = receiveName + ' ' + brokerName
              this.receiverAddress = brokerAddress
            } else {
              this.receiverName = receiveName
              this.receiverAddress = receiveAddress
            }
            this.ctrInfo.contractSeq = seq
            this.ctrInfo.ctrLockType = lockType
            this.ctrInfo.contractNumber = contractNumber
            this.ctrInfo.contractFileName = contractFileName
            this.goDetail()
            /* getContractLock({ contractSeq : seq, lockType : lockType }).then(response => {
              this.ctrInfo.contractSeq = seq
              this.ctrInfo.failCnt = response.rdata.failCnt
              this.ctrInfo.ctrLockType = lockType
              this.ctrInfo.contractNumber = contractNumber
              this.ctrInfo.contractFileName = contractFileName
              if(this.ctrInfo.ctrLockType === 1) {
                this.purCertInfo.certRegNo = response.rdata.certRegNo
              }
              if(this.ctrInfo.ctrLockType === 2 || this.ctrInfo.ctrLockType === 4) {
                this.perCerInfo.perName = response.rdata.perName
                this.perCerInfo.perNumber = response.rdata.perNumber
              }
              if(this.ctrInfo.failCnt>4) {
                this.$refs.confirm.open('alert', '인증잠김', '해당 계약은 인증 5번 실패했습니다. 고객센터에 문의해주세요')
              }else if(this.ctrInfo.ctrLockType === 0 || response.rdata.acq === "Y") {
                this.$nextTick(() => {
                  this.goDetail()
                })
              }else if(this.ctrInfo.ctrLockType === 1) {
                this.$nextTick(() => {
                  this.$refs.pubCert.open()
                })
              }else if(this.ctrInfo.ctrLockType === 2) {
                this.$nextTick(() => {
                  this.$refs.perCert.open()
                })
              }else if(this.ctrInfo.ctrLockType === 3) {
                this.$nextTick(() => {
                  this.$refs.passCheck.open()
                })
              }else if(this.ctrInfo.ctrLockType === 4) {
                this.$nextTick(() => {
                  this.$refs.passCheck.open()
                })
              }
            }).catch(e => {
              console.error(e)
            }) */
          }else{
            this.ctrInfo.contractSeq = seq
            this.ctrInfo.contractNumber = contractNumber
            this.goDetail()
          }
        }
      }
    },
    handleSizeChange (val) {
      this.pageParam.page = 0
      this.pageParam.size = val
      this.getContractList()
    },
    handleCurrentChange (val) {
      this.pageParam.page = (val - 1)
      this.getContractList()
    },
    handlePageChange(value) {
      this.pageParam.page = (value - 1)
      this.getContractList()
    },
    getContractList () {
      if (this.searchParams !== null) {
        var searchParams = this.searchParams
        searchParams.pageParam = this.pageParam
        this.$refs.loading.start('리스트 조회 중입니다.')
        getContractList(searchParams).then(response => {
          this.$refs.loading.end()
          this.contractList = response.rdata.contractList
          var a = 0
          if(parseInt(response.rdata.totalCnt % 10) > 0) {
            a = 1
          }
          this.total = parseInt(response.rdata.totalCnt / 10) + a
        }).catch(e => {
          console.error(e)
        })
      }
    },
    purCertResult: function(vid, errorMessage, sign, certPEM) {
      this.errorMessage = errorMessage
      if(vid) {
        ctrLockReadSuc(JSON.stringify({ contractSeq: this.ctrInfo.contractSeq, contractNumber: this.ctrInfo.contractNumber, contractFileName: this.ctrInfo.contractFileName, receiverName: this.receiverName, receiverAddress: this.receiverAddress  })).then(
          this.$nextTick(() => {
            this.goDetail()
          })
        )
      } else {
        this.ctrInfo.failCnt = this.ctrInfo.failCnt+1
        ctrLockReadFail(JSON.stringify({ contractSeq: this.ctrInfo.contractSeq, failCnt: this.ctrInfo.failCnt })).then(
          this.$nextTick(() => {
            this.$refs.confirm.open('alert', '인증실패', '인증 ' + this.ctrInfo.failCnt + '번 실패하였습니다.<br>' + this.errorMessage)
            if(this.ctrInfo.failCnt<5) {
              this.$refs.pubCert.open()
            }
          })

        )
      }
    },
    perCertResult: function(vid, errorMessage) {
      this.errorMessage = errorMessage
      if(vid) {
        ctrLockReadPerSuc(JSON.stringify({ contractSeq: this.ctrInfo.contractSeq, ci: this.errorMessage, contractNumber: this.ctrInfo.contractNumber, contractFileName: this.ctrInfo.contractFileName, receiverName: this.receiverName, receiverAddress: this.receiverAddress  })).then(
          this.$nextTick(() => {
            this.goDetail()
          })
        )
      }else{
        this.ctrInfo.failCnt = this.ctrInfo.failCnt+1
        ctrLockReadFail(JSON.stringify({ contractSeq: this.ctrInfo.contractSeq, failCnt: this.ctrInfo.failCnt })).then(
          this.$nextTick(() => {
            this.$refs.confirm.open('alert', '인증실패', '인증 ' + this.ctrInfo.failCnt + '번 실패하였습니다.<br>' + this.errorMessage)
            if(this.ctrInfo.failCnt<5) {
              this.$refs.perCert.open(this.perCerInfo.perName, this.perCerInfo.perNumber)
            }
          })

        )
      }
    },
    passCheckResult: function(result) {
      if(result) {
        if(this.ctrInfo.ctrLockType === 4) {
          this.$refs.perCert.open()
        } else {
          ctrLockReadSuc(JSON.stringify({ contractSeq: this.ctrInfo.contractSeq, contractNumber: this.ctrInfo.contractNumber, contractFileName: this.ctrInfo.contractFileName, receiverName: this.receiverName, receiverAddress: this.receiverAddress })).then(
            this.$nextTick(() => {
              this.goDetail()
            })
          )
        }
      } else {
        this.ctrInfo.failCnt = this.ctrInfo.failCnt+1
        ctrLockReadFail(JSON.stringify({ contractSeq: this.ctrInfo.contractSeq, failCnt: this.ctrInfo.failCnt })).then(
          this.$nextTick(() => {
            this.$refs.confirm.open('alert', '인증실패', '인증 ' + this.ctrInfo.failCnt + '번 실패하였습니다.<br>')
            if(this.ctrInfo.failCnt<5) {
              this.$refs.passCheck.open(this.certRegNo)
            }
          })

        )
      }
    },
    getSelfContract(senderAddress, receiverAddress, senderBrokerAddress, receiverBrokerAddress) {
      var useraddr = this.$store.state.user.useraddr

      if(useraddr === senderAddress || useraddr === receiverAddress || useraddr === senderBrokerAddress || useraddr === receiverBrokerAddress) {
        return true
      }else {
        return false
      }
    },
    goDetail() {
      if (this.ctrInfo.contractStatus === 'XX') {
        this.$refs.confirm.open('alert', '계약열람', '현재 해당계약서는 열람할 수 없습니다.')
      } else {
        if(this.ctrInfo.contractNumber.indexOf('DWF-') >= 0) {
          this.$router.push({
            name: 'contractDongwonDetail',
            params: { contractSeq: this.ctrInfo.contractSeq }
          })
        } else if (this.ctrInfo.contractNumber.indexOf('SJDR-') >= 0 ||
                  this.ctrInfo.contractNumber.indexOf('SJOY-') >= 0) {
          this.$router.push({
            name: 'sajoDetail',
            params: { contractSeq: this.ctrInfo.contractSeq }
          })
        } else {
          this.$router.push({
            name: 'contractDetail',
            params: { contractSeq: this.ctrInfo.contractSeq }
          })
        }
      }
    }
  }
}
</script>
